export const success = {
  Success: 'Sucesso',
  'Your contract was successfully reparceled!':
    'Seu contrato foi reparcelado com sucesso!',
};
